<template>
    <div class="root">
        <div class="hh-register-container margin-top-50">
            <div class="panel panel-default">
                <div class="container-fluid">
                    <div v-if="isLoading" class="section-body margin-top-50 margin-bottom-50">
                        <LoadingAnimation/>
                    </div>
                    <div class="section section-body" v-show="!isLoading">
                        <div class="row">
                                            <div class="col-sm-12">
                        <div class="no-border">
                            <h1 class="form-title">
                                {{formTitle}} 
                            </h1>
                        </div>
                    </div>
                         <div v-if="step === 1" class="col-sm-12">
                              <h3>
                                Personal Information
                              </h3>
                                <div v-if="role === 'organizer'" class="margin-0 hint-text">This information will be verified in order to fully
                                  activate your account and enable all features. Please fill in the exact information as it's
                                  present on your tax documents.
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="progress-bar-wrapper" :class="`step-${progressBarLength}`">
                                    <ProgressBar
                                            :length="progressBarLength"
                                            :step="step"
                                            @componentLoading="componentLoading"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-20" v-if="dataAnalysed">
                            <div class="col-sm-12 form margin-bottom-30">
                                <Step1 v-if="step === 1"
                                       @formSubmitted="formSubmitted"
                                       @componentLoading="componentLoading"
                                       :userData="userData.dataStep1"
                                       :staticData="staticData"
                                       :userRoles="userRoles"
                                       :identities="identities"
                                />
                                <Step2 v-if="step === 2"
                                       @formSubmitted="formSubmitted"
                                       @componentLoading="componentLoading"
                                       @navigateBack="navigateBack"
                                       @navigateNext="navigateNext"
                                       :userData="userData.dataStep2"
                                       :staticData="staticData"
                                       :config="config"
                                       :userRoles="userRoles"
                                />
                                  <Step4 v-if="step === 3 && role == 'organizer'"
                                       @formSubmitted="formSubmitted"
                                       @componentLoading="componentLoading"
                                       @navigateBack="navigateBack"
                                       @navigateNext="navigateNext"
                                       :userData="userData.dataStep4"
                                       :staticData="staticData"
                                       :userRoles="userRoles"
                                />
                                 <!-- <Step3 v-if="step === 3"
                                       @formSubmitted="formSubmitted"
                                       @componentLoading="componentLoading"
                                       @navigateBack="navigateBack"
                                       @navigateNext="navigateNext"
                                       :userData="userData.dataStep3"
                                       :staticData="staticData"
                                       :userRoles="userRoles"
                                /> -->
                              
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Step1 from './steps/Step-1'
  import Step2 from './steps/Step-2'
  import Step4 from './steps/Step-4'
  import ProgressBar from '../../components/ProgressBar'
  import LoadingAnimation from '../../components/LoadingAnimation'
  import { scrollTop } from '../../utils/componentHelper'

  export default {
    name: 'Form',

    components: {
      Step1,
      Step2,
      Step4,
      ProgressBar,
      LoadingAnimation,
    },

    props: {},

    data: () => {
      return {
        step: 1,
        loading: true,
        dataAnalysed: false,
        config: {},
        componentsLoadingStatus: {
          ProgressBar: true,
          stepComponent: true,
        },
        userData: {
          verified: false,
          roles: null,
          dataStep1: {},
          dataStep2: {},
          dataStep3: {},
          dataStep4: {},
        },
        userRoles: null,
        identities: null,
        staticData: {},
      }
    },

    beforeMount () {
      if (_.isEmpty(this.registerData)) {
        this.$store.dispatch('fetchRegisterData').then(() => {
          this.dataAnalysed = false
          this.loading = true
          this.analyseUserData()
        })
      } else {
        this.dataAnalysed = false
        this.loading = true
        this.analyseUserData()
      }
    },

    mounted () {
      this.loading = true
    },

    methods: {
      fillUserData () {
        this.userData.verified = this.registerData.data.attributes.verified
        this.userRoles = this.registerData.data.attributes.roles
        this.identities = this.registerData.data.attributes.identities

        this.step = this.registerData.data.attributes.step + 1

        this.fillDataStep1()
        this.fillDataStep2()
        this.fillDataStep4()
      },

      fillDataStep1 () {
        this.userData.dataStep1.email = this.registerData.data.attributes.email
        this.userData.dataStep1.first_name = this.registerData.data.attributes.first_name
        this.userData.dataStep1.last_name = this.registerData.data.attributes.last_name
        this.userData.dataStep1.business_name = this.registerData.data.attributes.business_name
        this.userData.dataStep1.phone = this.registerData.data.attributes.phone
        this.userData.dataStep1.date_of_birth = this.registerData.data.attributes.date_of_birth
         this.userData.dataStep1.profile_image = this.registerData.data.attributes.profile_image
      },

      fillDataStep2 () {
        if (!_.isEmpty(this.registerData.data.relations.contact)) {
          let contactData = this.registerData.data.relations.contact.data.attributes

          this.userData.dataStep2.billingAddress = {
            billing_first_name: contactData.billing_first_name,
            billing_last_name: contactData.billing_last_name,
            billing_address_1: contactData.billing_address_1,
            billing_address_2: contactData.billing_address_2,
            billing_country: contactData.billing_country,
            billing_city: contactData.billing_city,
            billing_state: contactData.billing_state,
            billing_zip: contactData.billing_zip,
          }
        }

        if (!_.isEmpty(this.registerData.data.relations.paymentInformation)) {
          let paymentInformation = this.registerData.data.relations.paymentInformation[0].data.attributes

          this.userData.dataStep2.paymentInformation = {
            name: paymentInformation.name,
            last4: paymentInformation.last4,
            brand: paymentInformation.brand,
          }
        }
      },

      // fillDataStep3 () {
      //   this.userData.dataStep3.date_of_birth = this.registerData.data.attributes.date_of_birth
       
      // },

      fillDataStep4 () {
        if (!_.isEmpty(this.registerData.data.relations.payoutInformation)) {
          let accountData = this.registerData.data.relations.payoutInformation.data.attributes
          this.userData.dataStep4 = { ...accountData }
        }
        this.userData.dataStep4.business_name = this.registerData.data.attributes.business_name
      },

      fillConfigData () {
        if (!_.isEmpty(this.registerData.config)) {
          this.config = this.registerData.config
        }
      },

      fillStaticData () {
        if (!_.isEmpty(this.registerData.data.staticData)) {
          this.staticData = { ...this.staticData, ...this.registerData.data.staticData }
        }
      },

      analyseUserData () {
        if (!_.isEmpty(this.registerData)) {
          this.fillUserData()
          this.fillConfigData()
          this.fillStaticData()

          if (this.userData.verified !== true) {
            window.location = '/email/verify'
            return
          }
        }

        if (_.isEmpty(this.userRoles) && !_.isEmpty(localStorage.getItem('userType'))) {
          this.userRoles = [localStorage.getItem('userType')]
        }

        this.dataAnalysed = true
        this.loading = false
      },

      navigateBack () {
        --this.step
          scrollTop()
      },

      navigateNext () {
        ++this.step
          scrollTop()
      },

      componentLoading (componentName, value) {
        this.componentsLoadingStatus[componentName] = value
      },

      formSubmitted () {
        this.loading = true
        this.$store.dispatch('fetchRegisterData').then(() => {
          this.dataAnalysed = false
          this.analyseUserData()
        })
      }
    },

    computed: {
      ...mapGetters({
        registerData: 'registerData',
        authUser: 'authUser',
      }),

      formTitle () {
        let defaultTitle = 'Registration'

        if (!_.isEmpty(this.userRoles)) {
            if (this.userRoles.includes('organizer')) {
              return `Fundraiser ${defaultTitle}`
            } else if (this.userRoles.includes('donor')) {
              return `Donor ${defaultTitle}`
            }
        }

        return 'Loading...'
      },

      role () {
        if (!_.isEmpty(this.userRoles) && this.userRoles.includes('organizer')) {
          return 'organizer'
        }

        return 'donor'
      },

      progressBarLength () {
        if (this.role === 'organizer') {
          return 3
        }

        return 2
      },

      isLoading () {
        for (let component in this.componentsLoadingStatus) {
          if (this.componentsLoadingStatus[component]) {
            return true
          }
        }

        return this.loading
      },

    },
  }
</script>

<style lang="scss" scoped>
    .root::v-deep {
       @import '../../../style/pages/register';
    }
  @media screen and (max-width: 1000px) {
     .hh-register-container.margin-top-50 {
      margin-top: 25px !important;
    }
  }

    .hint-text {
    font-family: Circular Std;
    font-style: normal;
    font-weight: 450;
    font-size: 14px;
    line-height: 15px;
    color: #AEAEAE;
  }

  .panel {
    padding: 1rem;
  }

  .no-border {
    border-bottom: none !important;
  }

  .form-title {
    font-family: Circular Std;
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    line-height: 33px;
    letter-spacing: -0.01em;
    color: #000000; 
  }

  h3 {
    font-family: Circular Std;
    font-style: normal;
    font-weight: 450;
    font-size: 20px;
    line-height: 15px;
    color: black; 
  }

   @media screen and (max-width: 767px) {
     h3 {
       font-size: 21px !important;
     }
    
  }
   
</style>
